import React from 'react';
import { BookOpen, Users, Star } from 'lucide-react';
export function SocialProof() {
  return <section className="py-8 px-4 bg-white" data-id="element-211">
      <div className="max-w-4xl mx-auto grid grid-cols-1 md:grid-cols-3 gap-4 md:gap-8" data-id="element-212">
        <div className="flex flex-col items-center justify-center p-6 bg-white rounded-2xl shadow-md border border-gray-100" data-id="element-213">
          <BookOpen className="w-10 h-10 text-blue-600 mb-3" data-id="element-214" />
          <span className="font-bold text-gray-800 text-lg" data-id="element-215">
            300+ risorse digitali
          </span>
        </div>
        <div className="flex flex-col items-center justify-center p-6 bg-white rounded-2xl shadow-md border border-gray-100" data-id="element-216">
          <Users className="w-10 h-10 text-blue-600 mb-3" data-id="element-217" />
          <span className="font-bold text-gray-800 text-lg" data-id="element-218">
            Migliaia di insegnanti
          </span>
        </div>
        <div className="flex flex-col items-center justify-center p-6 bg-white rounded-2xl shadow-md border border-gray-100" data-id="element-219">
          <Star className="w-10 h-10 text-blue-600 mb-3 fill-current" data-id="element-220" />
          <span className="font-bold text-gray-800 text-lg" data-id="element-221">
            4.9/5 valutazione
          </span>
        </div>
      </div>
    </section>;
}